import { useApolloClient } from '@apollo/client';
import { Accordion, AccordionItem, EmptyStation } from '@axinom/mosaic-ui';
import clsx from 'clsx';
import React from 'react';
import { useParams } from 'react-router-dom';
import {
  EnvironmentManagedServiceLogsOrderBy,
  useEnvironmentManagedServiceLogsQuery,
} from '../../../../generated/id-service-env-administration';
import type { BreadcrumbResolver } from '../../../../models/breadcrumb';
import classes from './ServicesLogMessages.module.scss';

export const ServicesLogMessages: React.FC = () => {
  const apolloClient = useApolloClient();
  const { envId } = useParams<{
    envId: string;
  }>();

  // Query log messages
  const { data } = useEnvironmentManagedServiceLogsQuery({
    client: apolloClient,
    variables: {
      condition: {
        environmentId: envId,
      },
      orderBy: [EnvironmentManagedServiceLogsOrderBy.CreatedAtDesc],
    },
    fetchPolicy: 'no-cache',
  });

  const dateFormatter: Intl.DateTimeFormat = new Intl.DateTimeFormat(
    navigator.language,
    {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    },
  );

  return (
    <EmptyStation title={`Service Log Messages`} subtitle={''}>
      <Accordion
        header={
          <div className={clsx(classes.row, classes.header)}>
            <span>Timestamp</span>
            <span>Service Name</span>
            <span>Message Type</span>
          </div>
        }
        stickyRows={true}
      >
        {data?.environmentManagedServiceLogs?.nodes.map((node) => (
          <AccordionItem
            key={node.id}
            header={
              <div className={clsx(classes.row)}>
                <span>{dateFormatter.format(new Date(node.createdAt))}</span>
                <span>{node.managedServiceId}</span>
                <span>{node.messageType}</span>
              </div>
            }
          >
            <div className={clsx(classes.content)}>
              <label>Message Body</label>
              <pre>{JSON.stringify(node.messageBody, undefined, 2)}</pre>
            </div>
          </AccordionItem>
        ))}
      </Accordion>
    </EmptyStation>
  );
};

export const ServicesLogMessagesCrumb: BreadcrumbResolver = () =>
  'Service Log Messages';
